<div class="modal" bsModal #modalEditComponent="bs-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog"  [class.modal-lg]="!config.small" [class.modal-md]="config.small">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{title}}</h4>
        <img *ngIf="config.resizeOrClose==='resize'" src="images/resize.png" alt="[resize]" class="pull-right" style="cursor: pointer;" (click)="resize()"/>
        <img *ngIf="config.resizeOrClose==='close'" src="images/close.png" alt="[close]" class="pull-right" style="cursor: pointer;" (click)="close()"/>
      </div>
      <div id="edited-content" class="modal-body" contenteditable="true">
        <ng-content></ng-content>
      </div>
      <div class="modal-footer">
        <span class="footer-message pull-left">{{config.footerMessage}}</span>
          <mat-checkbox class="property-checkbox"
                        [checked]="injectProperty"
                        (change)="addProp($event.checked)">
              Add internal view tag
          </mat-checkbox>
        <button type="button" [ngClass]="config.okBtnCssClass"  (click)="accept()" [innerHTML]="config.okBtnTitle"></button>
        <button *ngIf="config.resubmitBtnTitle!==''" type="button" [ngClass]="config.okBtnCssClass"  (click)="resubmit()" [innerHTML]="config.resubmitBtnTitle"></button>
       </div>
    </div>
  </div>
</div>
